import AformItem from '@/components/AformItem';
import './index.css';

export default {
  name: 'BfEditor',
  components: {
    AformItem,
  },
  props: {
    value: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: () => false },
    margin: { type: String, default: () => '0' },
    pure: { type: Boolean, default: () => true },
    must: { type: Boolean, default: () => false },
    inline: { type: Boolean, default: () => false },
    size: { type: String, default: () => 'small' },
    rules: { type: Object, default: () => ({}) },
    labelWidth: { type: String, default: () => '100%' },
    labelPosition: { type: String, default: () => 'top' },
    itemWidth: { type: String, default: () => '' },
    cols: { type: String, default: () => '1' },
    gutter: { type: String, default: () => '10' },
    config: { type: Object, default: () => ({}) },
    values: { type: Object, default: () => ({}) },
    label: { type: Boolean, default: () => true },
    check: { type: Boolean, default: () => true },
    action: { type: Boolean, default: () => true },
    loading: { type: Boolean, default: () => false },
    fileRemoveMark: { type: String, default: () => 'will-remove' },
    finishText: { type: String, default: () => '保存' },
    submitText: { type: String, default: () => '确定' },
    rejectText: { type: String, default: () => '' },
    cancelText: { type: String, default: () => '取消' },
  },
  data() {
    return {
      form: this.value,
      randomKey: `key-${Math.random()}`,
    }
  },
  created() {
    this.create();
  },
  destroyed() {
    this.create = null;
    this.verify = null;
    this.finish = null;
    this.submit = null;
    this.reject = null;
    this.cancel = null;
    this.filter = null;
    this.result = null;
    this.format = null;
  },
  watch: {
    values: {
      immediate: true,
      handler() {
        this.create();
      },
    }
  },
  methods: {
    create() { // 创建表单 格式化表单配置对象(this.config)为数据双向绑定对象
      this.randomKey = `key-${Math.random()}`;
      const { config = {}, values = {} } = this;
      let temp = {};
      let data = {};
      if (config && Object.keys(config).length > 0) {
        for (let a in config) temp[a] = '';
      }
      if (values && Object.keys(values).length > 0) { // 设置默认值
        for (let a in temp) {
          if (a.includes('password')) data[a] = '';
          else data[a] = isNaN(values[a]) ? values[a] : (values[a] != null ? `${values[a]}` : '');
        }
      } else {
        if (!this.pure) {
          for (let a in config) { // 设置 object 对象(单选框, 下拉框, 开关) 默认值为0
            const { pure = null, type = null, ...r } = config[a];
            if (!pure) {
              if (type && (type == 'radio' || type == 'select' || type == 'switch')) {
                data[a] = r.default || '0';
              } else data[a] = r.default || '';
            } else data[a] = '';
          }
        } else {
          for (let a in temp) data[a] = '';
        }
      }
      this.form = data;
    },
    verify() { // 表单验证
      let change = false;
      let success = false;
      this.$refs['form'].validate(valid => {
        if (valid) {
          success = true;
          let result = this.refine(this.form);
          let values = this.refine(this.values);
          Object.keys(result).forEach(a => (result[a] != values[a]) && (change = true));
        }
      });
      return change && success;
    },
    finish(e) {
      e && e.preventDefault();
      this.$emit('finish', this.result());
    },
    submit(e) { // 提交表单
      e && e.preventDefault();
      if (!this.check) this.$emit('submit');
      this.$refs['form'].validate(valid => {
        if (valid) {
          let data = {};
          if (Object.keys(this.config).length > 0) {
            for (let a in this.config) { // 格式化数据模糊查询
              if (this.form[a] && Object.keys(this.form[a]).length > 0 && this.form[a].old && this.form[a].old.split('=')[1] != '') { // 判断是否有默认图片删除
                const { old } = this.form[a];
                data[a] = this.form[a];
                data[`${a}-${this.fileRemoveMark}`] = old;
              } else data[a] = this.form[a];
            }
          }
          let change = false;
          let result = this.refine(data);
          let values = this.refine(this.values);
          Object.keys(result).forEach(a => (result[a] != values[a]) && (change = true));
          if (change) this.$emit('submit', this.filter(result));
          return result;
        }
      });
    },
    refine(form = {}) {
      let data = {};
      Object.keys(form).forEach(a => {
        if ((a != undefined && a != 'undefined') && (form[a] != '%' && form[a] != '%%' && form[a] != 'null' && form[a] != 'undefined' && form[a] != null && form[a] != undefined)) {
          data[a] = form[a];
        } else data[a] = '';
      });
      return data;
    },
    reject(e) {
      e && e.preventDefault();
      this.$emit('reject', this.result());
    },
    regain() {
      this.$refs['form'] && this.$refs['form'].resetFields();
    },
    cancel(e) {
      e && e.preventDefault();
      this.$emit('cancel', this.form);
      this.$nextTick(() => {
        for (let a in this.form) this.form[a] = '';
        this.$nextTick(() => this.$refs['form'] && this.$refs['form'].resetFields());
      });
    },
    filter(form = {}) { // 过滤空值属性
      const data = {};
      for (let a in form) {
        if ((a != undefined && a != 'undefined') && (form[a] != '%' && form[a] != '%%' && form[a] != 'null' && form[a] != 'undefined' && form[a] != null && form[a] != undefined)) {
          data[a] = form[a];
        }
      }
      return data;
    },
    result() { return this.filter(this.form) },
    format(a, b) {
      const { ...r } = this.config[a];
      const text = r.label || r.title || r.text;
      const must = { required: true, trigger: 'blur', message: `${text}不能为空` };
      const rule = (r['rule'] ? r['rule'] : ((r['must'] || this.must) ? [{ ...must }] : []));
      const rules = (this.disabled || r.disabled) ? [] : ((r['must'] && r['rule']) ? [{ ...must }, ...r['rule']] : rule);
      const config = { form: this.form, size: r.size ? r.size : this.size, field: a, disabled: this.disabled || this.loading, change: () => this.change(), ...r };
      return (
        <el-form-item
          key={b}
          name={a}
          prop={a}
          rules={rules}
          style={{ width: r.width ? r.width : this.itemWidth }}
          label={this.label ? (r.type && r.type == 'checkbox' ? '' : text) : ''}
        >
          {r.hint ? (
            <el-row gutter={Number(this.gutter)}>
              <el-col span={12}>
                <AformItem config={config} />
              </el-col>
              <el-col span={12}>
                <span class="hint">{`(${r.hint})`}</span>
              </el-col>
            </el-row>
          ) : (<AformItem config={config} />)}
        </el-form-item>
      )
    },
    change() {
      this.$emit('input', this.form);
      this.$emit('change', this.form);
    },
  },
  render() {
    const { ...attrs } = this.$attrs;
    const { finish, submit, reject, cancel } = this.$listeners;
    return (
      <div class={!this.inline ? 'b-f-editor vertical' : 'b-f-editor'} style={{ padding: this.margin }}>
        <div class={this.disabled ? 'disabled' : ''}>
          <el-form
            ref="form"
            size={this.size}
            inline={this.inline}
            labelWidth={this.labelWidth}
            labelPosition={this.labelPosition}
            props={{ model: this.form, rules: Object.keys(this.rules).length > 0 ? this.rules : null }}
            {...{ attrs }}
          >
            <el-row gutter={(this.cols != '') ? (this.gutter != '' ? Number(this.gutter) : 0) : 0}>
              {Object.keys(this.config).map((a, b) => ((this.config[a].span && this.config[a].span != '') || this.cols != '') ? (
                <el-col key={b} span={(Number(this.config[a].span) || (24 / Number(this.cols)))}>
                  {this.format(a, b)}
                </el-col>
              ) : this.format(a, b))}
              {this.$slots.default}
            </el-row>
            {(finish || submit || reject || cancel) && (
              <div class="action">
                <el-form-item name="action">
                  {finish && this.finishText != '' && <el-button loading={this.loading} type="success" on-click={this.finish}>{this.finishText}</el-button>}
                  {submit && this.submitText != '' && <el-button loading={this.loading} type="primary" on-click={this.submit}>{this.submitText}</el-button>}
                  {reject && this.rejectText != '' && <el-button loading={this.loading} type="danger" on-click={this.reject}>{this.rejectText}</el-button>}
                  {cancel && this.cancelText != '' && <el-button disabled={this.loading} on-click={this.cancel}>{this.cancelText}</el-button>}
                </el-form-item>
              </div>
            )}
          </el-form>
        </div>
      </div>
    );
  }
}